import { ITheme, IPersonaStyles, IButtonStyles, IImageStyles } from 'office-ui-fabric-react';

export const tooltipMaxWidth: number = 320;

export interface LastEditedStyles {
  subComponentStyles: {
    persona?: Partial<IPersonaStyles>;
    personaButton?: IButtonStyles;
    tooltipPersona?: Partial<IPersonaStyles>;
    personaCoinImage?: Partial<IImageStyles>;
  };
}

export interface LastEditedStyleProps {
  theme?: ITheme;
}

export function getLastEditedDefaultStyle(props: LastEditedStyleProps): LastEditedStyles {
  const { theme } = props;

  const personaFontSize = `14px`;
  const personaFontFamily = `Segoe UI, sans-serif`;

  return {
    subComponentStyles: {
      persona: {
        root: {
          flexDirection: 'row-reverse',
          display: 'inline-flex'
        },
        details: {
          paddingLeft: 0,
          paddingRight: 4
        },
        primaryText: {
          fontSize: personaFontSize,
          fontFamily: personaFontFamily,
          color: theme ? theme.palette.neutralSecondary : '#606060'
        }
      },
      personaButton: {
        root: {
          paddingLeft: 8,
          paddingRight: 6,
          border: 'none',
          backgroundColor: 'transparent',
          borderRadius: 4,
          [':hover']: {
            backgroundColor: theme ? theme.palette.neutralLight : '#EDEBE9'
          }
        }
      },
      tooltipPersona: {
        primaryText: {
          fontSize: personaFontSize,
          fontFamily: personaFontFamily,
          color: theme ? theme.palette.neutralPrimary : '#323232'
        }
      },
      personaCoinImage: {
        root: {
          marginRight: '10px',
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          border: 0,
          borderRadius: '50%',
          perspective: '1px'
        }
      }
    }
  };
}
